// Print a post's real GPS position as a typographic artifact — the kind
// of micro-detail that makes the page feel like a field journal. Returns
// null when the post has no coordinates.
export default function coordinateLine(location) {
  if (
    !location ||
    !location.coordinates ||
    !Array.isArray(location.coordinates.coordinates)
  )
    return null;
  const [longitude, latitude] = location.coordinates.coordinates;
  if (typeof latitude !== 'number' || typeof longitude !== 'number')
    return null;
  const lat = `${Math.abs(latitude).toFixed(4)}° ${latitude >= 0 ? 'N' : 'S'}`;
  const lng = `${Math.abs(longitude).toFixed(4)}° ${
    longitude >= 0 ? 'E' : 'W'
  }`;
  return `${lat} · ${lng}`;
}
